import { render, staticRenderFns } from "./TableSize.vue?vue&type=template&id=d56fd336&"
import script from "./TableSize.vue?vue&type=script&lang=js&"
export * from "./TableSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports